define('views/components/distributor_settings/company_settings',['require','views/base/item_page_view','typeahead','bloodhound','text!templates/components/distributor_settings/company_settings.html'],function(require){

    var BaseItemPageView = require('views/base/item_page_view');
    require('typeahead');
    require('bloodhound');

    var temp = require("text!templates/components/distributor_settings/company_settings.html");
    return BaseItemPageView.extend({
        // html template for the view
        template: _.template(temp),

        afterInitialize: function () {

        },

        ui: function() {
            return {
                select2Input: '[data-init-plugin="select2"]',
                mainForm : '#main-form',
                submitButton: '#submit-button',

                chainField: '.chains-typeahead',
                cityField: '.cities-typeahead',

                countrySelect: '#country',
                phoneCountrySelect: '#phone_country'
            };
        },

        events: {
            'change form input': 'formChanged',
            'change form textarea': 'formChanged',
            'change form select': 'formChanged',

            'click @ui.submitButton': 'submitButtonClicked',

            'change @ui.countrySelect': 'countryChanged'
        },

        afterRender: function () {
            var _this = this;

            // Setup typeahed for city field
            var citiesTypeahedEngine = new Bloodhound({
                datumTokenizer: Bloodhound.tokenizers.whitespace,
                queryTokenizer: Bloodhound.tokenizers.whitespace,
                remote: {
                    url: App.Config.apiBase + 'cities/typeahead/',
                    replace: function(url, query) {
                        var modifiedUrl = url + ('?query=' + _this.ui.cityField.val());

                        if (_this.model.get('country')) {
                            modifiedUrl += ('&country=' + _this.model.get('country'));
                        }

                        return modifiedUrl;
                    }
                },
                identify: function(obj) {
                    return obj.id;
                }
            });

            this.ui.cityField.typeahead({
                minLength: 3
            }, {
                name: 'cities',
                source: citiesTypeahedEngine,
                display: 'name'
            });
        },

        setupFormValidation: function () {
            this.ui.mainForm.validate({
                rules: {
                    'company_name': "required",
                    'country': "required",
                    'city_name': "required",
                    'phone_country': "required",
                    'phone_value': "required",
                    'foundation_year': "required",
                    "service_types": "required",
                    'address': "required"
                },
                messages: {
                    'company_name': App.polyglot.t('company_name_required'),
                    'country': App.polyglot.t('country_required'),
                    'city_name': App.polyglot.t('city_required'),
                    'phone_country': App.polyglot.t('phone_country_required'),
                    'phone_value': App.polyglot.t('phone_value_required'),
                    'foundation_year': App.polyglot.t('foundation_year_required'),
                    "service_types": App.polyglot.t('service_types_required'),
                    'address': App.polyglot.t('address_required')
                },

                onfocusout: false,
                onkeyup: false,
                onclick: false,

                showErrors: function (errorMap, errorList) {
                    for (var i=0; i<errorList.length; i++) {
                        App.utils.showMessage('error', errorList[i].message);
                    }
                }
            });
        },

        countryChanged: function () {
            var country_id = this.ui.countrySelect.val();

            if (country_id) {
                // Select same country in phone number field
                this.ui.phoneCountrySelect.val(country_id);
                this.ui.phoneCountrySelect.trigger('change');
            }
        }
    });
});
